<template>
  <div class="modal-body">
    <h3 class="modal-title">CONTACT US</h3>
    <div class="modal-content">
      <contact-us-form/>
    </div>
  </div>
</template>
<script>
import ContactUsForm from '@/components/ContactUsForm.vue';

export default {
  components: {
    ContactUsForm,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modals/ContactUsModal.vue